import React from 'react'
import { observer } from 'mobx-react-lite'
import InitialAvatar from 'shared/components/InitialAvatar/InitialAvatar'
import CheckBox from 'shared/ui/CheckBox/CheckBox'
import useStudentAccordion from './hooks/useStudentAccordion'
import AssignmentSubmissionRouter from './components/AssignmentSubmissionRouter/AssignmentSubmissionRouter'
import s from './styles/StudentAccordion.module.scss'
import { ReactComponent as PenIcon } from 'assets/icons/pen-circle.svg'
import { ReactComponent as ArrowIcon } from 'assets/icons/arrow_short_right.svg'
import Button from 'shared/ui/Button/Button'

const StudentAccordion = observer(
	({ student, assignment, isOpen, onToggle }) => {
		const {
			isOpen: accordionIsOpen,
			studentGrade,
			handleToggle,
			handleCheckboxToggle,
			handleViewProfile,
			isSelected,
			studentStatus,
			statusText,
			isMobile,
		} = useStudentAccordion({ student, isOpen, onToggle })

		return (
			<div className={s.accordion}>
				<div
					className={s.header}
					onClick={handleToggle}
					role="button"
					tabIndex={0}
					onKeyDown={e => {
						if (e.key === 'Enter' || e.key === ' ') {
							e.preventDefault()
							handleToggle()
						}
					}}
				>
					<div className={s.header__inner}>
						<div className={s.avatar}>
							<InitialAvatar
								name={student.name || 'Unknown'}
								size={isMobile ? 35 : 52}
								studentId={student.id}
								student={student}
								onClick={e => {
									e.stopPropagation()
									handleViewProfile()
								}}
							/>
						</div>
						<div className={s.header__info}>
							<div className={s.header__title}>
								<button
									type="button"
									className={s.header__name}
									onClick={e => {
										e.stopPropagation()
										handleViewProfile()
									}}
								>
									{student.name || 'Unknown Student'}
								</button>
								{student.isNew ? <span className={s.newBadge}>NEW</span> : null}
								{studentGrade && (
									<span className={s.header__grade}>{studentGrade}</span>
								)}
							</div>
							<span className={`${s.status} ${s[studentStatus]}`}>
								<span className={s.status__icon}>
									<PenIcon />
								</span>
								<span className={s.status__text}>Status: {statusText}</span>
							</span>
						</div>
					</div>
					<div className={s.header__actions}>
						<div className={s.select}>
							<CheckBox
								isSelected={isSelected}
								onToggle={handleCheckboxToggle}
								variant="checkmark"
								className={s.select__checkbox}
								classNameLabel={s.select__label}
							/>
						</div>
						<span className={` ${s.arrow} ${accordionIsOpen ? s.open : ''}`}>
							<ArrowIcon />
						</span>
					</div>
				</div>

				<div
					className={`${s.content} ${accordionIsOpen ? s.content_open : ''}`}
				>
					<div className={s.content__inner}>
						<div className={s.content__body}>
							{assignment && (
								<AssignmentSubmissionRouter
									assignment={assignment}
									student={student}
								/>
							)}
							<Button
								type="button"
								className={s.profileButton}
								onClick={handleViewProfile}
							>
								Go to Student Profile &gt;
							</Button>
						</div>
					</div>
				</div>
			</div>
		)
	},
)

export default StudentAccordion
